export const WHATS_APP_ORIGIN = 'https://wa.me';
